import React from "react";

// import icons
import { social } from "../../constants";

const Socials = () => {
  return (
    <ul className="flex space-x-4  justify-center items-center">
      {social.map((item, index) => {
        return (
          <li
            className="flex justify-center items-center text-accent"
            key={index}
          >
            <a className="text-base" href={item.href}>
              {item.iconHeader}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default Socials;
